export default {
  computed: {
    expToNextLevel() {
      if (!this.sprite) return 0;
      return this.getExpForLevel(this.sprite.level);
    },
    expToPrevLevel() {
      if (!this.sprite) return 0;
      if (!this.sprite.level || this.sprite.level === 0) return 0;
      return this.getExpForLevel(this.sprite.level - 1);
    },
    spriteExp() {
      if (!this.sprite) return 0;
      return this.sprite.experience || 0;
    },
    expPercent() {
      const current = this.spriteExp - this.expToPrevLevel;
      const total = this.expToNextLevel - this.expToPrevLevel;
      return (current / total) * 100;
    },
    tokenId() {
      if (!this.sprite) return '';
      let { tokenId } = this.sprite;
      if (tokenId && tokenId.indexOf && tokenId.indexOf('-') !== -1) tokenId = undefined;
      return tokenId;
    },
  },
  methods: {
    getExpForLevel(level) {
      if (!level) level = 0;
      const nextLevel = level + 1;
      const numberOfNewActions = nextLevel + 10;
      const numberOfBaseActions = 1 + 10;

      const start = ((numberOfNewActions - numberOfBaseActions) + 1);
      const numerator = start * (numberOfNewActions + numberOfBaseActions);
      const arithsum = numerator / 2;
      const experienceRequiredToLevel = arithsum * 10;

      return experienceRequiredToLevel;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/spriteStats.js